import { conf } from '@/config/conf'
import axios from 'axios'
import store from '@/store'

interface ContractRequestArgs {
    objectId?: string|number
    filter?: []
    sort?: []
}

export function getContractsRequest(args: ContractRequestArgs = {}) {
    return new Promise(( resolve, reject ) => {
        const request = axios({
            url: conf.apiUrl + '/Contract/getContracts',
            method: "POST",
            data: args || {},
            headers: {
                xsrf: conf.xsrf,
                Authorization: 'Bearer ' + store.getters.user.accessToken
            }
        });

        request.then(function( res: any ) {
            resolve(res.data)
        });

        request.catch(function( reason: any) {
            reject(reason)
            // TODO:  general error handler !!
        });
    })
}